__turbopack_context__.v({
  "container": "TopRibbon-module-scss-module__ZlFLBq__container",
  "localeLink": "TopRibbon-module-scss-module__ZlFLBq__localeLink",
  "skipLink": "TopRibbon-module-scss-module__ZlFLBq__skipLink",
  "topRibbon": "TopRibbon-module-scss-module__ZlFLBq__topRibbon",
});
